$(document).ready (function (){
  
  
  var PathName = window.location.pathname;
  
  if(PathName == '/products/gay-beer-golden-lager' || PathName == '/collections/taprm-exclusive/products/gay-beer-golden-lager'){
    window.location.href = window.location.origin + '/collections/gaybeer';
  }
  
  /* ==================== HEADER SCROLL FUNCTION ==================== */
  var pageURL = $(location).attr("href");
  if(pageURL == 'https://taprm.com/'){
    $('body').append('<style>.search-header__input::placeholder{color:#fff}</style>')
    $('body').append('<style>.search-header__input{color:#fff}</style>')
    $(window).scroll(function(){
      if($(this).scrollTop() > 0 ){
        $('.site-header').addClass('white-site-header');
        $('body').append('<style>.search-header__input::placeholder{color:black}</style>')
        $('body').append('<style>.search-header__input{color:black}</style>')

      } else {
        $('.site-header').removeClass('white-site-header');
        $('body').append('<style>.search-header__input::placeholder{color:#fff}</style>')
        $('body').append('<style>.search-header__input{color:#fff}</style>')
      }
    }); 
  } else {
    $(window).scroll(function(){
      if($(this).scrollTop() > 0 ){
        $('.site-header').addClass('white-site-header');
      } else {
        $('.site-header').removeClass('white-site-header');
      }
    });
  }
  
  checkCookie('gate');
  
  $('#on-yes').on('click', function(e){
    e.preventDefault();
    setCookie('gate', 'yes', 30);
   /* $('body section#on-age-popup').fadeOut('show');*/
  });
  
  
  $('.accordion-tab').on('click', function(){
    var ID = $(this).attr('data-index');
    $('.accordion-tab').removeClass('active'),
    $(this).addClass('active');
    $('.accordion-content').removeClass('active');
    $('.accordion-content-' + ID).addClass('active');
  });
  
   $('.mobile-site-nav li button').on('click', function(){
    $(".site-nav__dropdown").hide();
      if($(this).hasClass('active')){
          console.log("first");          
          $(this).closest('li').find('.site-nav__dropdown').css('display', 'none');
          $(this).removeClass('active');
          $(".site-nav__dropdown").hide();
      } else {
          console.log("second");
          $("button.btn--link.site-nav__link.site-nav__link--main").removeClass('active');
        	
          $(this).closest('li').find('.site-nav__dropdown').css('display', 'block');
          $(this).addClass('active');
      }
  });

  // get exported products from another environment
  const searchParams = new URL(window.location.href).searchParams;
  if (searchParams && searchParams.get('location')) {
    setCookie('zip', searchParams.get('location'));
  }

  if (searchParams && searchParams.get('cartProducts')) {
    const cartProducts = JSON.parse(decodeURIComponent(searchParams.get('cartProducts')))
    $.getJSON('/cart.js').then(cartProductsRes => {
      let allProductsChecked = false;
      let activeAddToCartRequests = 0;
      let productAddedCount = 0;
      cartProducts.map((el, index) => {
        if(index === cartProducts.length - 1) {
          allProductsChecked = true;
        }

        $.ajax({
          type: "GET",
          url: `${window.location.origin}/search?type=product&q=variants.sku:${el[0]}&view=sku`,
          dataType: "json",
          async: false,
          success: function (res) {
            if (res.products && res.products.length) {
              productAddedCount++;
              res.products.map(product => {
                const variantToAdd = product.variants.find(variant => variant.sku === el[0])
                if (cartProductsRes.items && cartProductsRes.items.find(variant => variant.sku === el[0])) {
                  activeAddToCartRequests++;
                  $.ajax({
                    type: "POST",
                    url: '/cart/change.js',
                    data: {id: variantToAdd.id, quantity: el[1]},
                    dataType: "json",
                    async: false,
                    success: () => {
                      activeAddToCartRequests--;
                      if(allProductsChecked && !activeAddToCartRequests && productAddedCount > 0) {
                        alert(productAddedCount + (productAddedCount > 1 ? ' products' : ' product') + ' added to cart! You will be redirected to your cart page!')
                        window.location.href = '/cart'
                      }
                    }
                  });
                } else {
                  activeAddToCartRequests++;
                  $.ajax({
                    type: "POST",
                    url: '/cart/add.js',
                    data: {id: variantToAdd.id, quantity: el[1]},
                    dataType: "json",
                    async: false,
                    success: () => {
                      activeAddToCartRequests--;
                      if(allProductsChecked && !activeAddToCartRequests && productAddedCount > 0) {
                        alert(productAddedCount + (productAddedCount > 1 ? ' products' : ' product') + ' added to cart! You will be redirected to your cart page!')
                        window.location.href = '/cart'
                      }
                    }
                  });
                }
              })
            } else {
              if(allProductsChecked && !activeAddToCartRequests && productAddedCount > 0) {
                alert(productAddedCount + (productAddedCount > 1 ? ' products' : ' product') + ' added to cart! You will be redirected to your cart page!')
                window.location.href = '/cart'
              }
            }
          }
        });
      });
    })
  }

  if (searchParams.get('ageChecked')) {
    setCookie('gate', 'yes');
    window.location.href = window.location.origin;
  }
  
});


function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  return true;
}

function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function checkCookie(gate) {
  var user = getCookie(gate);
  if (user != "yes") {
    $('body section#on-age-popup').fadeIn('show');
  }
}
